import { ExternalLinkProps } from "./types";
import { cn } from "@/lib/utils";
import { ExternalLink as ExternalLinkIcon } from "lucide-react";

export const ExternalLink = ({
  label,
  url,
  inNewTab = true,
  color,
  onClick,
  className,
  ...props
}: ExternalLinkProps) => {
  const baseClasses = cn(
    "inline-flex items-center gap-1 text-sm font-medium text-cede-primary transition-colors hover:text-cede-primary/80",
    color,
    className,
  );

  return (
    <a
      href={url}
      target={inNewTab ? "_blank" : ""}
      rel="noopener noreferrer"
      data-testid="anchor"
      onClick={onClick}
      className={baseClasses}
      {...props}
    >
      {label}
      <ExternalLinkIcon className="h-4 w-4" />
    </a>
  );
};
